function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { Suspense, useState } from 'react';
import SectionUserDayWeekMonth from './users/section-user-day-week-month';
import { Button } from 'antd';
import { SkeletonYearLineChart } from '../sekeletons/skeleton-year-line-chart';
import SectionUserReportChart from './users/section-user-report-total';
import { GENDER_OPTIONS } from '../../contants/gender';
import WeekMonthFilter from '../components/filter/week-month-filter';
export default function SectionUser() {
    const now = new Date();
    const _useState = useState({
        mode: 'year',
        year: now.getFullYear()
    }), _useState2 = _slicedToArray(_useState, 2), params = _useState2[0], setParams = _useState2[1];
    const _useState3 = useState(undefined), _useState4 = _slicedToArray(_useState3, 2), gender = _useState4[0], setGender = _useState4[1];
    return /*#__PURE__*/ React.createElement("div", {
        className: "sale mt-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-4 mb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-white p-3 rounded-[8px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-3"
    }, GENDER_OPTIONS.map(g => /*#__PURE__*/ {
        var _a;
        return React.createElement(Button, {
            key: (_a = g.value) !== null && _a !== void 0 ? _a : 'all',
            onClick: () => setGender(g.value),
            className: gender === g.value ? '!bg-[#f0c52a36]' : ''
        }, g.label);
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "bg-white p-3 rounded-[8px]"
    }, /*#__PURE__*/ React.createElement(WeekMonthFilter, {
        value: params,
        onChange: setParams
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 lg:grid-cols-4 gap-8"
    }, /*#__PURE__*/ React.createElement(SectionUserDayWeekMonth, {
        gender: gender === 'male' ? 1 : gender === 'female' ? 2 : undefined,
        params: params
    }), /*#__PURE__*/ React.createElement("div", {
        className: "lg:col-span-3 bg-white shadow rounded-xl p-4"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonYearLineChart, null)
    }, /*#__PURE__*/ React.createElement(SectionUserReportChart, {
        gender: gender,
        params: params,
        onChange: setParams
    })))));
}
